export const isDateValid = (date: Date) => !isNaN(new Date(date).getDate())
